import { database } from "firebase/app";

export default {
  addedBy: "none",
  bookType: "TXT",
  dateAdded: database.ServerValue.TIMESTAMP,
  isArchived: false,
  isProcessing: false,
  isProcessingFailed: false,
  isWasOpened: false,
  lastOpenDate: database.ServerValue.TIMESTAMP,
  location: 0,
  status: "",
  title: "new record",
  updatedByDeviceId: "",
  wordCount: 0,
  wpm: 0,
};
